export default __webpack_public_path__ + "static/logo-99ef701d143ff50948d8cfe75ed29eed.svg";